import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FiX } from "@react-icons/all-files/fi/FiX";
import Modal from "components/Modal";
import { modalStyleProp } from "helpers/modalStyles";
import ShareView from "./components/ShareView/ShareView";
import QrView from "./components/QrView/QrView";
import InstagramShare from "./components/InstagramShare/InstagramShare";
import DownloadAssetView from "./components/DownloadAssetView/DownloadAssetView";
import "./_style.scss";
const modalStyle = {
    content: {
        maxWidth: "340px",
        maxHeight: "90vh",
        padding: "2.4rem",
        background: "#ffffff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "16px",
    },
    overlay: {
        ...modalStyleProp().overlay,
        zIndex: 1200,
    },
};
function ShareModal({ isOpen, onClose, title, onShareClick, shareItem, }) {
    var _a;
    const [copied, setCopied] = useState(false);
    const [view, setView] = useState("share");
    const [imageLoadFailed, setImageLoadFailed] = useState(false);
    const fbAppId = (_a = window.FB_ID) !== null && _a !== void 0 ? _a : "";
    useEffect(() => {
        if (isOpen) {
            setView("share");
        }
    }, [isOpen]);
    useEffect(() => {
        if (!shareItem.imageUrl) {
            return undefined;
        }
        let cancelled = false;
        setImageLoadFailed(false);
        const image = new Image();
        image.onerror = () => {
            if (!cancelled) {
                setImageLoadFailed(true);
            }
        };
        image.src = shareItem.imageUrl;
        return () => {
            cancelled = true;
            image.onerror = null;
        };
    }, [shareItem.imageUrl]);
    const handleCopy = () => {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
        onShareClick === null || onShareClick === void 0 ? void 0 : onShareClick("url_copy");
    };
    const qrUrlObject = new URL(shareItem.url);
    qrUrlObject.searchParams.set("utm_source", "qrcode");
    const qrUrl = qrUrlObject.toString();
    const downloadUrlObject = new URL(shareItem.url);
    downloadUrlObject.searchParams.set("utm_medium", "download");
    const downloadUrl = downloadUrlObject.toString();
    const canShareImage = !!shareItem.imageUrl && shareItem.imageUrl !== "" && !imageLoadFailed;
    const renderView = () => {
        if (["instagram", "instagram-story", "download-assets"].includes(view) && !canShareImage) {
            setView("share");
        }
        switch (view) {
            case "qr":
                return _jsx(QrView, { qrUrl: qrUrl, onBack: () => setView("share") });
            case "download-assets":
                return (_jsx(DownloadAssetView, { shareItem: shareItem, shareUrl: downloadUrl, onBack: () => setView("share") }));
            case "instagram":
                return (_jsx(InstagramShare, { shareItem: shareItem, onBack: () => setView("share"), type: shareItem.type }));
            case "instagram-story":
                return (_jsx(InstagramShare, { shareItem: shareItem, onBack: () => setView("share"), type: shareItem.type, isStory: true }));
            case "share":
            default:
                return (_jsx(ShareView, { shareItem: shareItem, fbAppId: fbAppId, copied: copied, onCopy: handleCopy, onChangeView: setView, canShareImage: canShareImage, onShareClick: onShareClick }));
        }
    };
    return (_jsx(Modal, { isOpen: isOpen, contentLabel: title, customStyle: modalStyle, "data-test": "social-share-modal", children: _jsxs("div", { className: "share-modal", children: [_jsxs("div", { className: "share-modal__header", children: [_jsx("h3", { className: "share-modal__title", children: title }), _jsx("button", { type: "button", onClick: onClose, className: "share-modal__close", "data-test": "share-modal-close", children: _jsx(FiX, {}) })] }), renderView()] }) }));
}
export default ShareModal;
